/**
 * Site-wide meta tags are a raw, user-supplied HTML string (project.meta_tags),
 * e.g. `<meta property="og:image" content="https://.../share.png" />`.
 *
 * To show admins what social share image a page will fall back to when they
 * haven't set one of their own, we need to pull the og:image (or twitter:image
 * as a secondary fallback) out of that string. Since it's user-authored HTML,
 * attribute order/quoting/self-closing isn't guaranteed, so we parse it with
 * the browser's own HTML parser instead of hand-rolling a regex.
 *
 * Returns the image URL, or null if none could be found.
 */
export function extractOgImage(metaTagsHtml) {
  if (!metaTagsHtml || typeof metaTagsHtml !== "string") return null;

  let doc;
  try {
    doc = new DOMParser().parseFromString(metaTagsHtml, "text/html");
  } catch (e) {
    return null;
  }

  const selectors = [
    'meta[property="og:image"]',
    'meta[name="og:image"]',
    'meta[property="og:image:url"]',
    'meta[name="twitter:image"]',
    'meta[property="twitter:image"]',
  ];

  for (const selector of selectors) {
    const tag = doc.querySelector(selector);
    const content = tag?.getAttribute("content")?.trim();
    if (content) return content;
  }

  return null;
}
